import React, { useState } from 'react';
const faqs = [{
  q: 'Wie erhalte ich das Material?',
  a: 'Sofort nach dem Kauf erhältst du einen Download-Link per E-Mail.'
}, {
  q: 'Ist es für alle Altersklassen geeignet?',
  a: 'Ja, das System deckt von Minis (U8) bis hin zur U18 und Senioren alles ab.'
}, {
  q: 'Kann ich das Material ausdrucken?',
  a: 'Absolut. Alle PDFs sind für den Druck optimiert, funktionieren aber auch perfekt auf Tablets.'
}, {
  q: 'Funktioniert es für Anfänger-Trainer?',
  a: 'Gerade für Anfänger ist es das perfekte Sicherheitsnetz, um sofort wie ein Profi aufzutreten.'
}, {
  q: 'Kann ich das Material auf mehreren Geräten nutzen?',
  a: 'Klar! Nach dem Kauf kannst du von jedem Gerät aus auf das Material zugreifen: Computer, Tablet oder Smartphone. Die Dateien sind im PDF-Format und mit allen Geräten kompatibel.'
}, {
  q: 'Wie funktioniert die 7-Tage-Garantie?',
  a: 'Wenn du aus irgendeinem Grund mit dem Kit nicht zufrieden bist, schreib uns einfach innerhalb von 7 Tagen nach dem Kauf und wir erstatten dir 100% des Betrags, ohne Fragen. Null Risiko für dich.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-bg-main py-24 px-4" data-id="element-86">
      <div className="max-w-3xl mx-auto" data-id="element-87">
        <h2 className="text-3xl sm:text-5xl font-black text-text-main text-center mb-12 tracking-tight" data-id="element-88">
          Häufig gestellte Fragen (FAQ)
        </h2>

        <div className="space-y-4 mb-16" data-id="element-89">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={`bg-bg-alt border rounded-2xl overflow-hidden transition-colors duration-300 ${isOpen ? 'border-primary/50 shadow-[0_0_20px_rgba(234,88,12,0.1)]' : 'border-border-light hover:border-white/20'}`} data-id="element-90">
                <button className="w-full text-left px-6 py-5 flex items-center justify-between gap-4" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} data-id="element-91">
                  <span className={`font-bold text-lg transition-colors ${isOpen ? 'text-primary' : 'text-text-main'}`} data-id="element-92">
                    {faq.q}
                  </span>
                  <span className={`text-2xl flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-45 text-primary' : 'text-text-sec'}`} data-id="element-93">
                    +
                  </span>
                </button>
                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-40 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-94">
                  <p className="text-text-sec text-base leading-relaxed" data-id="element-95">
                    {faq.a}
                  </p>
                </div>
              </div>;
        })}
        </div>

        {/* Final CTA */}
        <div className="text-center relative" data-id="element-96">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full rounded-full pointer-events-none" style={{
          background: 'radial-gradient(circle, rgba(16,185,129,0.15) 0%, transparent 70%)'
        }} data-id="element-97"></div>
          <a href="#pricing" className="relative btn-primary-pulse bg-cta-green font-black text-lg sm:text-2xl px-8 sm:px-12 py-4 sm:py-5 rounded-2xl hover:bg-cta-green-hover transition-colors inline-block mb-4 w-full sm:w-auto max-w-2xl text-gray-900 shadow-[0_0_30px_rgba(16,185,129,0.3)] border border-white/20" data-id="element-98">
            💪 JA! ICH WILL MEIN TRAINING JETZT REVOLUTIONIEREN
          </a>
          <p className="text-text-sec text-sm font-medium flex items-center justify-center gap-2" data-id="element-99">
            <span data-id="element-100">⚡ Sofortiger Zugriff</span>
            <span data-id="element-101">•</span>
            <span data-id="element-102">🛡️ 7 Tage Garantie</span>
          </p>
        </div>
      </div>
    </section>;
}